import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Grid, useMediaQuery } from '@material-ui/core';

// STYLES
import { SRegistrationSuccessTemplate } from './styles';

function RegistrationSuccessTemplate({ skipButton, linkButton, linkDescription, type, className }) {
  const matchesUpSm = useMediaQuery(theme => theme.breakpoints.up('sm'));

  return (
    <SRegistrationSuccessTemplate className={clsx(className, type && `type-${type}`)}>
      <Grid
        container
        spacing={matchesUpSm ? 2 : 4}
        direction={matchesUpSm ? 'row-reverse' : 'column'}
        alignItems="center"
        justifyContent="flex-end"
      >
        <Grid item xs={12} sm="auto">
          <div className="ext-link-wrapper">
            {linkButton}
            <p className="p5">{linkDescription}</p>
          </div>
        </Grid>
        <Grid item xs={12} sm="auto">
          {skipButton}
        </Grid>
      </Grid>
    </SRegistrationSuccessTemplate>
  );
}

RegistrationSuccessTemplate.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  skipButton: PropTypes.any,
  linkButton: PropTypes.any,
  linkDescription: PropTypes.any,
};

export default RegistrationSuccessTemplate;
